import { Copy, Save } from "../../../assets/icons";
import { LABELS } from "../../labels/jetlift/jetlift.labels";

export const buttonGroupOptions = [
    { id: 1, icon: '', label: "Comparison", type: "" },
    { id: 2, icon: '', label: "Well data report", type: "" },
    { id: 3, icon: '', label: "Main report", type: "primary" },
];

export const copyButtonOptions = [
    { id: 1, icon: <Copy />, label: "Copy", type: "" }
];

export const saveButtonOptions = [
    { id: 1, icon: <Save />, label: "Save project", type: "primary" }
];

export const calculateButtonOptions = [
    { id: 1, icon: "", label: "Calculate", type: "primary" }
];

export const createNewCaseButtonOptions = [
    { id: 2, icon: "", label: "Create new case", type: "secondary" }
];

export const duplicateCaseButtonOptions = [
    { id: 2, icon: "", label: "Duplicate case", type: "secondary", className: 'w-full' }
];

export const viewButtonOptions = [
    { id: 3, icon: "", label: "View", type: "primary", className: 'w-full' }
];

export const case1ProductionOptions = [
    { id: "1", name: "Case 1: High Production" },
    { id: "2", name: "Case 1: Mid Production" },
    { id: "3", name: "Case 1: Low Production" }
];

export const case2ProductionOptions = [
    { id: "1", name: "Case 2: High Production" },
    { id: "2", name: "Case 2: Mid Production" },
    { id: "3", name: "Case 2: Low Production" }
];

export const case3ProductionOptions = [
    { id: "1", name: "Case 3: High Production" },
    { id: "2", name: "Case 3: Mid Production" },
    { id: "3", name: "Case 3: Low Production" }
];

export const designTypeButtonOptions = [
    { id: 1, label: LABELS?.esp, disabled: false, icon: "", width: "[50%]" },
    { id: 2, label: LABELS?.jetLift, disabled: false, icon: "", width: "[50%]" }
];

export const projectHeaderButtonOptions = [
    { id: 1, icon: "", label: LABELS?.jetLiftSizing, type: "primary" },
    { id: 2, icon: "", label: LABELS?.comparison, type: "primary" },
    { id: 3, icon: "", label: LABELS?.reports, type: "primary" },
];

export const equipmentOptions = [
    { value: '0', label: 'Active' },
    { value: '1', label: 'International' },
    { value: '2', label: 'Permian' },
    { value: '3', label: 'Active + Obsolete' }
];